// @flow
import type { Answer } from 'types/answer'
import type { Question } from 'types/question'
import ConditionalRulesResolver from 'utils/conditionalRulesResolver'

function visibleByConditionalRulesHelper(
  question: Question,
  answers: ?Array<Answer>,
  questions: Array<Question>
): boolean {
  const conditionalRulesResolver = new ConditionalRulesResolver(
    answers,
    questions
  )

  return conditionalRulesResolver.resolveQuestion(question)
}

const getDjangoFormsErrors = (error: { detail: any }): any => {
  if (error.detail) {
    const djangoErrors = Object.keys(error.detail).reduce(
      (acc, key) => ({
        ...acc,
        [key]: error.detail[key].join(' '),
      }),
      {}
    )
    return djangoErrors
  }
  return {}
}

export { getDjangoFormsErrors, visibleByConditionalRulesHelper }
